//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const AMBASSADORS_ACCESS_PERMISSION = 'ambassadors:access';
